module.exports = __webpack_public_path__ + "media/images/shark/Francis-p-500-1be2813c90f87f48d57b69b893605d65.jpeg";